/* eslint-disable jira/naming/disallow-filenames */
import React, { type ComponentType } from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyServicedeskCmdbLandingPage: LazyComponent<React.ComponentType<Record<any, any>>> =
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	lazyForPaint<ComponentType<Record<any, any>>>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-cmdb-landing-page", jiraSpaEntry: "async-servicedesk-cmdb-landing-page" */ '@jira/spa-apps__servicedesk-cmdb-landing-page/src/index.tsx'
			),
	);

const LandingPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbLandingPage}
		pageId="spa-apps/servicedesk/insight/cmdb-landing-page"
		shouldShowSpinner
	/>
);

export default LandingPage;
